export const convertDateToUnixTimestamp = (date) => (Math.floor(date.getTime() / 1000));


